import PosthogService from '~/services/posthog/PosthogService';

export function fireReportIncidentNoShowClicked(): void {
  PosthogService.getInstance().track('dental_portal:report_incident:no_show_clicked');
}
